import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-ink-900 border-t border-white/5 text-cream/80"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-4">
                    <Link to="/" data-testid="footer-logo">
                        <img
                            src="/logo-dogaparquet.png"
                            alt="Dogaparquet di Gianluca Occhipinti"
                            className="h-20 w-auto object-contain object-left"
                        />
                    </Link>
                    <p className="mt-6 text-sm text-cream/60 leading-relaxed max-w-sm">
                        L’arte del legno, la qualità che dura. Posa, restauro
                        e consulenza per pavimenti in legno a Modica e in
                        tutta la Sicilia sud-orientale.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="text-xs uppercase tracking-widest text-brass mb-5">
                        Navigazione
                    </p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a
                                href="/#chi-siamo"
                                data-testid="footer-link-chi-siamo"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                Chi siamo
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#servizi"
                                data-testid="footer-link-servizi"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                Servizi
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#portfolio"
                                data-testid="footer-link-portfolio"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                Portfolio
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#recensioni"
                                data-testid="footer-link-recensioni"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                Recensioni
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#contatti"
                                data-testid="footer-link-contatti"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                Contatti
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-5">
                    <p className="text-xs uppercase tracking-widest text-brass mb-5">
                        Contatti
                    </p>
                    <ul className="space-y-4 text-sm">
                        <li className="flex items-start gap-3">
                            <MapPin
                                size={16}
                                className="mt-1 text-brass shrink-0"
                            />
                            <span data-testid="footer-address">
                                Via Variante S.S. 115, 45 — Modica (RG)
                            </span>
                        </li>
                        <li className="flex items-center gap-3">
                            <Phone size={16} className="text-brass shrink-0" />
                            <a
                                href="tel:+393891983122"
                                data-testid="footer-phone"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                389 198 3122
                            </a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail size={16} className="text-brass shrink-0" />
                            <a
                                href="mailto:info@dogaparquet.it"
                                data-testid="footer-email"
                                className="hover:text-brass transition-colors duration-500"
                            >
                                info@dogaparquet.it
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/5">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream/40">
                    <p data-testid="footer-copyright">
                        © {year} Dogaparquet di Gianluca Occhipinti. Tutti i
                        diritti riservati.
                    </p>
                    <p data-testid="footer-vat">P.IVA 01778420883</p>
                </div>
            </div>
        </footer>
    );
}
